export default "__VITE_ASSET__DcvCKMxV__"